import React from 'react';

import { EmailField } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { GuestEmailType, CustomEmail } from 'Jsx/CheckoutV4/types';

const GuestUser: React.FC<{
  guestEmail: GuestEmailType;
  onEmailChange: (email: CustomEmail) => void;
  emailLabel?: string;
}> = ({ guestEmail, onEmailChange, emailLabel, ...props }) => {
  const { t } = useTranslation();

  if (guestEmail) {
    return (
      <div className="flex flex-col w-full">
        <div className="w-full">
          <EmailField
            data-testid="email-field"
            full
            onEmailChange={onEmailChange}
            label={emailLabel || t('EMAIL_LABEL')}
            errorText={guestEmail.errorTextEmail}
            {...props}
          />
        </div>
      </div>
    );
  }
  return null;
};

export default GuestUser;
